var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTAccountsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550 120",
    role: "img",
    "aria-label": "t-accounts logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10,10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#1B2E3C",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    width: 6,
    height: 60,
    rx: 3,
    fill: "#1B2E3C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 22,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#1B2E3C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 38,
    width: 18,
    height: 6,
    rx: 3,
    fill: "#3CB7A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 54,
    width: 24,
    height: 6,
    rx: 3,
    fill: "#3CB7A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 46,
    width: 22,
    height: 6,
    rx: 3,
    fill: "#3CB7A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 62,
    width: 18,
    height: 6,
    rx: 3,
    fill: "#3CB7A6"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 82,
    fontFamily: "'Patrick Hand SC','Architects Daughter','Segoe Print','Comic Sans MS', Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
    fontSize: 72,
    fontWeight: 500,
    letterSpacing: 1.4,
    fill: "#1B2E3C"
  }, "\n    t-accounts\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTAccountsLogo);
export default __webpack_public_path__ + "static/media/t-accounts-logo.e6ab338664a6f70f449750cfae4a6e40.svg";
export { ForwardRef as ReactComponent };